import React from "react";
import TQJ from "../assets/images/TQJ.jpg";


const FjjDetails = () => {
  return (
    <section className="team-details">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-lg-5">
            <div className="team-details__content">
              <h2 className="team-details__title">贴签设备</h2>
              <h3 className="team-details__subtitle" style={{ fontWeight: "bold" }}>设计理念</h3>
              <p className="team-details__text">
                结构简单、耐用、可靠。设计原理上就将故障发生的可能性降到最低。
                部件选用上遵循“大马拉小车”的原则，保证部件寿命的足够设计冗余，以满足医院这一特殊用户群体的无故障要求。
                所有子系统均要满足软件硬件double-check的原则，以保证系统的稳定可靠杜绝故障的发生。

              </p>
              <h3 className="team-details__subtitle" style={{ fontWeight: "bold" }}>产品特点</h3>
              <p className="team-details__text">
                <strong style={{ color: "black" }}>贴签准确率:</strong>
                系统实时比对、机器视觉识别溶媒，医嘱、药品一致才贴签，杜绝药品差错事故。
                机器视觉高速解析条形码或二维码，复核输液准确性。<br />
                <strong style={{ color: "black" }}>兼容性：</strong>
                品规：500ml及以下所有规格的输液溶媒，包括塑瓶、塑袋、圆瓶等。
                正反：支持正反双面识别及正反双面贴签。<br />
                <strong style={{ color: "black" }}>高效性：</strong>
                实时高速打印识别，真空吸附贴签（＞2000袋/小时）。
                采用机械手柔性贴签+机械手抚平，保证各品规溶无差别自适应贴签。
              </p>
            </div>
          </div>
          <div className="col-lg-6">
            <h2 style={{ color: "black" }} >运用场景</h2>
            <p className="team-details__text">
              自动接收医嘱信息，实时打印医嘱标签，并自动将标签贴附在溶媒上。
            </p><br />
            <div className="team-one__single">
              <div className="course-one__image">
                <img src={TQJ} alt="" />
              </div>

              <div className="team-one__content">
                <h2 className="team-one__name">
                  <a href="/team-details">贴签设备</a>
                </h2>
                <p className="team-one__designation">苏州卫捷</p>
              </div>
              <div className="team-one__social">
                <a href="#none">
                  <i className="fab "></i>
                </a>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FjjDetails;
